import { Text } from "react-native-paper";
import { Anchor } from "../../components";

import Button from "../../components/Button";
import PopOver from "../../components/PopOver";
import { useIntercomClient } from "../../hooks/useIntercom";
import { PLAN_DETAILS_LINK } from "../links";
import { EligibilityStatus } from "../types";

interface Props {
  onDismiss(): void;
  visible: boolean;
  eligibilityStatus?: EligibilityStatus;
  enrolled?: boolean;
}

export default function IneligibleModal({ onDismiss, visible, eligibilityStatus, enrolled }: Props) {
  const intercom = useIntercomClient();
  let ineligibleReason = "something is wrong";

  switch (eligibilityStatus) {
    case EligibilityStatus.NON_COACH:
      ineligibleReason = "that you are not a member registered with a coach account";
      break;

    case EligibilityStatus.NON_MEMBER:
      ineligibleReason = "you are not a PGA member";
      break;

    case EligibilityStatus.INELIGIBLE_CLASS:
      ineligibleReason = "you are not part of an eligible member class";
      break;

    case EligibilityStatus.INACTIVE:
      ineligibleReason = "your membership status is not active";
      break;

    case EligibilityStatus.EMPLOYEE:
      ineligibleReason = "you are a current PGA employee";
  }

  const handleContactMembershipServices = () => {
    intercom.presentMessageComposer();
  };

  return (
    <PopOver {...{ onDismiss, visible }}>
      <Text className="text-title-5 font-700 text-center">You do not meet eligibility requirements.</Text>

      <Text className="text-link-normal font-400 text-center mt-6">
        {enrolled ? (
          <>
            You're not eligible to submit points because records indicate {ineligibleReason}. Please resolve the issue to
            continue your participation in the Deferred Compensation Plan. If you feel this is an error please{"\n"}
            <Text className="underline text-primary text-center font-400" onPress={handleContactMembershipServices}>
              contact member services.
            </Text>
          </>
        ) : (
          <>
            You're currently not eligible to enroll because records indicate {ineligibleReason}. If you feel this is an error
            please{"\n"}
            <Text className="underline text-primary text-center font-400" onPress={handleContactMembershipServices}>
              contact member services.
            </Text>
          </>
        )}
      </Text>

      <Anchor
        target="_blank"
        aClassName="text-regular-normal font-500 text-center mt-12 mb-6 text-primary"
        href={PLAN_DETAILS_LINK}
      >
        Review eligibility requirements
      </Anchor>

      <Button mode="secondary" onPress={onDismiss}>
        Close
      </Button>
    </PopOver>
  );
}
